/** JSON-LD relations may arrive as an IRI or as an embedded representation. */
export function resourceIri(value: string | {'@id'?: string} | null | undefined): string | null {
  return typeof value === 'string' ? value : value?.['@id'] || null;
}
